import { useEffect, useReducer, useRef } from 'react';

/**
 * “合并多行选择”列的表头全选 checkbox。
 *
 * 勾选会选中当前过滤后所有可选的行，取消则全部取消。
 *
 * 注意：该列依赖表格开启了 rowSelection（多选），否则 api.setNodesSelected 不会生效。
 */
function GroupSelectionHeader(params) {
  const { api } = params;
  const inputRef = useRef(null);
  // ag-grid 的 React header 组件不会在数据加载、selectionChanged 时自动重渲染，
  // 这里订阅事件手动触发重渲染，否则表头会停留在初始（无数据）状态一直 disabled。
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const refresh = () => forceUpdate();
    api.addEventListener('selectionChanged', refresh);
    api.addEventListener('modelUpdated', refresh);
    return () => {
      if (!api.isDestroyed()) {
        api.removeEventListener('selectionChanged', refresh);
        api.removeEventListener('modelUpdated', refresh);
      }
    };
  }, [api]);

  const getSelectableNodes = () => {
    const nodes = [];
    api.forEachNodeAfterFilterAndSort((node) => {
      if (node.data && node.data.selectable !== false) {
        nodes.push(node);
      }
    });
    return nodes;
  };

  const selectableNodes = getSelectableNodes();
  const selectedCount = selectableNodes.filter((n) => n.isSelected()).length;
  const checked = selectableNodes.length > 0 && selectedCount === selectableNodes.length;
  const indeterminate = selectedCount > 0 && selectedCount < selectableNodes.length;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = !checked && indeterminate;
    }
  }, [checked, indeterminate]);

  const handleChange = () => {
    if (api.isDestroyed()) {
      return;
    }
    api.setNodesSelected({
      nodes: selectableNodes,
      newValue: !checked,
      source: 'checkboxSelected',
    });
  };

  return (
    <label className="icp-group-selection-checkbox icp-group-selection-header">
      <input
        ref={inputRef}
        type="checkbox"
        checked={checked}
        disabled={selectableNodes.length === 0}
        onChange={handleChange}
      />
    </label>
  );
}

export default GroupSelectionHeader;
